import * as React from "react";
import {
  TrashSolidIcon,
  RefreshIcon,
  ShieldIcon,
} from "@8x8/oxygen-icon/icons";
import { humanizeFromMilliseconds } from "@/vue/utils/time";

const ICONS_STYLE = Object.freeze({ fill: "white" });

const describeEvent = (timestamp, notes = null) => {
  let text = `Done on ${humanizeFromMilliseconds(timestamp)}`;
  if (notes) {
    text += `. Reason: "${notes}"`;
  }

  return text;
};

const reAddEventMilestoneItem = (author, timestamp, notes) => ({
  id: `readd_event_${timestamp}`,
  title: `Customer re-added to whitelist by ${author}`,
  description: describeEvent(timestamp, notes),
  isCompleted: true,
  icon: <RefreshIcon style={ICONS_STYLE} />,
});

const removeEventMilestoneItem = (author, timestamp, notes) => ({
  id: `remove_event_${timestamp}`,
  title: `Customer removed from whitelist by ${author}`,
  description: describeEvent(timestamp, notes),
  isCompleted: true,
  icon: <TrashSolidIcon style={ICONS_STYLE} />,
});

const creationEventMilestoneItem = (author, timestamp) => ({
  id: `initial_creation_event_${timestamp}`,
  title: `Customer whitelisted by ${author}`,
  isCompleted: true,
  description: describeEvent(timestamp),
  icon: <ShieldIcon style={ICONS_STYLE} />,
});

/**
 * Computes the milestones for {@see @8x8/oxygen-milestone-tracker}.
 */
export default (customer) => {
  if (!customer) {
    return [];
  }

  const items = [];
  if (customer.addedNotes) {
    items.push(
      reAddEventMilestoneItem(
        customer.addedBy,
        customer.addedDateTime,
        customer.addedNotes
      )
    );
  } else {
    // If we do not have any notes for the addition, it means
    // that this is an initial creation event.
    items.push(
      creationEventMilestoneItem(customer.addedBy, customer.addedDateTime)
    );
  }

  if (customer.removedDateTime) {
    items.push(
      removeEventMilestoneItem(
        customer.removedBy,
        customer.removedDateTime,
        customer?.removedNotes
      )
    );
  }

  // Sort chronologically
  items.sort((x, y) => x.datetime - y.datetime);

  return items;
};
